export default __webpack_public_path__ + "static/media/Specialised Application 2.8f722cbf.jpg";